import { Game } from '../game.model';

export class Begin {
  game: Game;
}
